module.exports = new __parcel__URL__("bossfight_notification_image.df73a8fb.png").toString();